import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';
import { DEFAULT_CURRENCY, type CurrencyCode } from '@/shared/types/currency.types';
import { isValidCurrency } from '@/utils/currency';

interface CurrencyContextValue {
  currency: CurrencyCode;
  setCurrency: (code: CurrencyCode) => void;
}

const STORAGE_KEY = 'onapila_currency';

const CurrencyContext = createContext<CurrencyContextValue | null>(null);

function loadCurrency(): CurrencyCode {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored && isValidCurrency(stored) ? stored : DEFAULT_CURRENCY;
}

export function CurrencyProvider({ children }: { children: ReactNode }) {
  const [currency, setCurrencyState] = useState<CurrencyCode>(loadCurrency);

  const setCurrency = useCallback((code: CurrencyCode) => {
    setCurrencyState(code);
    localStorage.setItem(STORAGE_KEY, code);
  }, []);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error('useCurrency doit être utilisé dans CurrencyProvider');
  return ctx;
}
